import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../../../../commonComponents/translate';
import InboxContainer from './components/InboxContainer';
import { colors } from '../../../../../services/utilityFunctions';

function InboxMessagePlaceholder({ t }) {
  const title = t('inbox_noNews');
  const description = t('inbox_noNews_description');

  return (
    <InboxContainer
      style={{
        '--news-item-bg': colors('inverse'),
        '--news-item-title': colors('dynamic'),
        '--news-item-text': '#6F6C80',
      }}
      title={title}
    >
      {description}
    </InboxContainer>
  );
}

InboxMessagePlaceholder.propTypes = {
  t: PropTypes.func.isRequired,
};

export default translate(InboxMessagePlaceholder);
